// extracted by mini-css-extract-plugin
export default {"mainContainer":"Header_mainContainer__-oOi5","logo":"Header_logo__LMMok","logoutButton":"Header_logoutButton__uMo7Q"};